module.exports = __webpack_public_path__ + "static/media/web02_eng.a918ddbf.png";